// extracted by mini-css-extract-plugin
module.exports = {"container":"container--U2DLG7Bi","header":"header--rfEG9ffn","title":"title--Yh9lOqn3","closeBtn":"closeBtn--D28XKITO","headerSpacer":"headerSpacer--JG20ZzYn"};